module.exports = __webpack_public_path__ + "static/img/degarde_join_us.6d766e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/degarde_join_us.jpg
// module id = 293
// module chunks = 1